<template>

    <div class="profile-dashboard__pets-list">

        <div class="profile-dashboard__pets-add">

            <a href="/publication/project" class="btn btn--secondary d-flex">
                Добавить проект <span>&plus;</span>
            </a>

        </div>

        <template v-if="projects.length && loaded">
            <div class="profile-dashboard__pets-slider" v-if="projects.length > 1">
                <swiper ref="swiper" class="swiper" :options="swiperOptionsAnimal">

                    <swiper-slide v-for="(project, idx) in projects" :key="idx">
                        <div class="profile-pet">
                            <div class="profile-pet__inner d-flex">
                                <div class="profile-pet__header profile-pet__header--project">

                                    <!-- TODO изображение origin, нужно поменять на вторичное. -->
                                    <div class="profile-pet__header-image"
                                         :class="{'grayscale': project.archive_reason === 'died'}"
                                         :style="'background-image: url(/storage'+ project.avatar.path.replace('original', 'preview_l') +')'"
                                         v-if="project.avatar"></div>

                                    <div class="archive-reason d-flex"
                                         v-if="project.archive_reason === 'home_found' || project.archive_reason === 'adopted_by_volunteer'">
                                        <img src="/assets/images/icons/home.svg" alt="">
                                    </div>

                                </div>

                                <div class="profile-pet__body">
                                    <div class="profile-pet__title d-flex">
                                        <a :href="'/projects/' + project.id" class="profile-pet__name"
                                           v-text="project.name"></a>
                                        <div class="profile-pet__location" v-if="project.city">
                                            {{ project.city.name }}
                                        </div>
                                    </div>
                                    <div class="profile-pet__description" v-text="project.ad_title"></div>
                                    <div class="rating">
                                        <p>{{ (+project.donationsProgress).toFixed() }} %</p>
                                        <div class="rating-block progress">
                                            <div class="filled" v-if="(+project.donationsProgress).toFixed() < 100"
                                                 :style="{width: (+project.donationsProgress).toFixed() < 100 ? (+project.donationsProgress).toFixed() + '%' : '',
                                                              background:  '#EE7372'}"></div>
                                            <div class="filled" v-if="(+project.donationsProgress).toFixed() >= 100"
                                                 :style="{width: '100%', background: '#91DA66'}"></div>
                                        </div>
                                    </div>

                                    <ul class="d-flex stats" v-if="(+project.donationsProgress).toFixed() < 100">
                                        <li>
                                            <p>{{ project.donationsTotal }} BYN</p>
                                            <span>Собрано</span>
                                        </li>
                                        <li class="line">
                                            <p>{{ project.need_sum }} BYN</p>
                                            <span>Цель</span>
                                        </li>
                                    </ul>

                                    <ul class="d-flex stats stats--done" v-else>
                                        <li>
                                            <p>
                                                {{ project.need_sum }} BYN
                                            </p>
                                            <span>
                                                    Цель достигнута
                                                <img src="/assets/images/icons/done.svg" alt="">
                                            </span>
                                        </li>
                                    </ul>


                                    <div class="info" v-if="loyalty && project.is_moderated !== 2 && project.is_moderated !== 3 && !project.up_allowed">
                                        Ваш проект будет подниматься автоматически каждые 6 часов
                                    </div>
                                    <div class="info" v-else-if="!loyalty && project.until_up_allowed">
                                        {{`Поднять проект можно ${project.until_up_allowed}`}}
                                    </div>

                                    <div class="actions d-flex">
                                        <a v-if="((project.up_allowed) && (project.user_id === user.id) && (project.is_moderated !== 2 && project.is_moderated !== 3) && !loyalty)"
                                           href="#" @click.prevent="actualizeProject(project.id)" class="btn">Поднять UP!</a>
                                        <a :href="'/publication/project/' + project.id" class="btn btn-light">Изменить</a>
                                    </div>


                                </div>
                            </div>

                        </div>

                    </swiper-slide>


                </swiper>

                <div class="slider-navigations">
                    <div id="projects-list-prev" class="swiper-button-prev" slot="button-prev"></div>
                    <div id="projects-list-next" class="swiper-button-next" slot="button-next"></div>
                </div>
            </div>
            <div class="d-flex" v-else>

                <div class="profile-pet" v-for="(project, idx) in projects" :key="idx">
                    <div class="profile-pet__inner d-flex">
                        <div class="profile-pet__header profile-pet__header--project">

                            <!-- TODO изображение origin, нужно поменять на вторичное. -->
                            <div class="profile-pet__header-image"
                                 :class="{'grayscale': project.archive_reason === 'died'}"
                                 :style="'background-image: url(/storage'+ project.avatar.path.replace('original', 'preview_l') +')'"
                                 v-if="project.avatar"></div>

                            <div class="archive-reason d-flex"
                                 v-if="project.archive_reason === 'home_found' || project.archive_reason === 'adopted_by_volunteer'">
                                <img src="/assets/images/icons/home.svg" alt="">
                            </div>

                        </div>

                        <div class="profile-pet__body">
                            <div class="profile-pet__title d-flex">
                                <a :href="'/projects/' + project.id" class="profile-pet__name"
                                   v-text="project.name"></a>
                                <div class="profile-pet__location" v-if="project.city">
                                    {{ project.city.name }}
                                </div>
                            </div>
                            <div class="profile-pet__description" v-text="project.ad_title"></div>
                            <div class="rating">
                                <p>{{ (+project.donationsProgress).toFixed() }} %</p>
                                <div class="rating-block progress">
                                    <div class="filled" v-if="(+project.donationsProgress).toFixed() < 100"
                                         :style="{width: (+project.donationsProgress).toFixed() < 100 ? (+project.donationsProgress).toFixed() + '%' : '',
                                                              background:  '#EE7372'}"></div>
                                    <div class="filled" v-if="(+project.donationsProgress).toFixed() >= 100"
                                         :style="{width: '100%', background: '#91DA66'}"></div>
                                </div>
                            </div>

                            <ul class="d-flex stats" v-if="(+project.donationsProgress).toFixed() < 100">
                                <li>
                                    <p>{{ project.donationsTotal }} BYN</p>
                                    <span>Собрано</span>
                                </li>
                                <li class="line">
                                    <p>{{ project.need_sum }} BYN</p>
                                    <span>Цель</span>
                                </li>
                            </ul>

                            <ul class="d-flex stats stats--done" v-else>
                                <li>
                                    <p>
                                        {{ project.need_sum }} BYN
                                    </p>
                                    <span>
                                                    Цель достигнута
                                                <img src="/assets/images/icons/done.svg" alt="">
                                    </span>
                                </li>
                            </ul>


                            <div class="info" v-if="loyalty && project.is_moderated !== 2 && project.is_moderated !== 3 && !project.up_allowed">
                                Ваш подопечный будет подниматься автоматически каждые 6 часов
                            </div>
                            <div class="info" v-else-if="!loyalty && project.until_up_allowed">
                                {{`Поднять проект можно ${project.until_up_allowed}`}}
                            </div>

                            <div class="actions d-flex">
                                <a v-if="((project.up_allowed) && (project.user_id === user.id) && (project.is_moderated !== 2 && project.is_moderated !== 3) && !loyalty)"
                                   href="#" @click.prevent="actualizeProject(project.id)" class="btn">Поднять UP!</a>
                                <a :href="'/publication/project/' + project.id" class="btn btn-light">Изменить</a>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </template>
        <template v-else-if="!loaded">
            <div class="profile-dashboard__pets-slider profile-dashboard__pets-slider--empty d-flex">
                <div class="LoaderBalls">
                    <div class="LoaderBalls__item"></div>
                    <div class="LoaderBalls__item"></div>
                    <div class="LoaderBalls__item"></div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="profile-dashboard__pets-slider profile-dashboard__pets-slider--empty d-flex">
                Список проектов пуст
            </div>
        </template>


    </div>


</template>

<script>
import { mapGetters } from 'vuex';
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

export default {
    name: "UserDashboardPets",
    components: {Swiper, SwiperSlide},
    props: ['user'],
    data() {
        return {
            projects: [],
            loaded: false,
            swiperOptionsAnimal: {
                slidesPerView: 2,
                spaceBetween: 24,
                loop: true,
                navigation: {
                    nextEl: '#projects-list-next',
                    prevEl: '#projects-list-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1, // or 'auto'
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                },
            },
        }
    },


    mounted() {
        this.getProjects()
    },

    watch: {
        projects() {
            setTimeout(() => {
                this.loaded = true
            }, 1000)
        }
    },

    computed: {

        ...mapGetters({
            loyalty: 'getUserLoyalty'
        })

    },


    methods: {

        actualizeProject(id) {
            axios.post('/projects/actualize', {'project_id': id})
                .then(response => {
                    response = response.data;
                })
                .then(response => {
                    this.getProjects();
                })
                .catch()
        },

        getProjects() {

            let params = {
                status: 1,
                per_page: 10,
                page: 1
            };

            axios.get(`/user/${this.user.id}/projects`, {params: params})
                .then(response => {
                    response = response.data

                    if (response.success) {
                        this.projects = response.data
                    }

                })
                .catch(error => {
                    error = error.response.data

                    if (!error.success) console.log(error)

                })
        }

    }

}
</script>

<style lang="scss" scoped>
.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6, .05, .15, .95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}

</style>
